export default __webpack_public_path__ + "static/media/A0002.1806ccee.png";